<template>
    <div class="container">
        <div class="container_banner">
            <img src="../../assets/image/Aboutus/car.png" />
        </div>
        <div class="originalstyle w">
            <div class="originalstyle_details">
                <div v-html="getdata.value"></div>
            </div>
            <div class="originalstyle_buttom" @click="Cinformation">
                <img src="../../assets/image/Aboutus/diagram.png" />
                <span class="location">商务合作</span>
            </div>
        </div>
        <el-dialog title="商务合作" :visible.sync="dialogVisible" width="45%">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px">
                <el-row :gutter="10">
                    <el-col :span="8">
                        <el-form-item label="联系姓名" prop="name">
                            <el-input v-model="ruleForm.name" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="手机号" prop="phone">
                            <el-input v-model="ruleForm.phone" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="公司名称" prop="company_name">
                            <el-input v-model="ruleForm.company_name" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item label="合作内容" prop="content">
                            <el-input v-model="ruleForm.content" type="textarea" rows="3"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="2">
                    <el-col :span="8">
                        <el-form-item label="验证码" prop="code">
                            <el-input v-model="ruleForm.code" size="mini"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="2">
                        <span @click="Verification">
                            <img :src="imgs" alt class="code" />
                        </span>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogcancel">取 消</el-button>
                <el-button type="primary" @click="Submission">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    data() {
        var mobile = (rule, value, cb) => {
            const reg = /^1[3456789]\d{9}$/;
            if (reg.test(value)) {
                return cb();
            }
            cb(new Error("请输入合法的手机号码"));
        };
        return {
            dialogVisible: false,
            imgs: "",
            ruleForm: {
                name: "",
                phone: "",
                company_name: "",
                code: "",
                code_id: "",
                content: "",
            },
            getdata: {},
            rules: {
                name: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                    {
                        min: 2,
                        max: 4,
                        message: "长度在 2 到 4 个字符",
                        trigger: "blur",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号码",
                        trigger: "blur",
                    },
                    { validator: mobile, max: 11, trigger: "blur" },
                ],
                company_name: [
                    {
                        required: true,
                        message: "请输入公司名称",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: true,
                        message: "请输入合作内容",
                        trigger: "blur",
                    },
                ],
                code: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur",
                    },
                    {
                        min: 4,
                        max: 4,
                        message: "长度为4个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    created() {
        this.getData();
        const randomNum = Math.ceil(Math.random() * 10000000);
        this.ruleForm.code_id = randomNum;
        this.imgs = `https://api.jianchejia.com.cn/v1/common/code?code_id=${randomNum}`;
    },
    methods: {
        async getData() {
            const { data: res } = await this.$ajax.get(
                "/v1/common/info?type=" + 1
            );
            if (res.code == 0) {
                this.getdata = res.data;
            }
        },
        Cinformation() {
            this.dialogVisible = true;
        },
        Verification() {
            const randomNum = Math.ceil(Math.random() * 10000000);
            this.ruleForm.code_id = randomNum;
            this.imgs = `https://api.jianchejia.com.cn/v1/common/code?code_id=${randomNum}`;
        },
        // 取消
        dialogcancel() {
            this.dialogVisible = false;
            this.$refs.ruleForm.resetFields();
        },
        // 提交
        Submission() {
            this.$refs.ruleForm.validate(async (val) => {
                if (!val) return this.$message.warning("请将信息填写完整");
                const { data: res } = await this.$ajax.post(
                    "/v1/website/business-cooperation",
                    this.ruleForm
                );
                if (res.code !== 0) return this.$message.warning(res.message);
                this.$message.success("发送成功");
                this.dialogVisible = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    .container_banner {
        width: 100%;
        height: 712px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .originalstyle {
        .originalstyle_details {
            width: 100%;
            min-height: 300px;
        }
        .originalstyle_buttom {
            width: 330px;
            height: 80px;
            margin: 60px auto;
            position: relative;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
            .location {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }
    .code {
        width: 130px;
        height: 30px;
        margin-left: 15px;
        cursor: pointer;
    }
}
</style>
